
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-map-pin-line',
      title: 'Rastreamento em Tempo Real',
      description: 'Acompanhe a localização exata do seu veículo a qualquer momento, com precisão GPS de alta tecnologia.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Central de Monitoramento 24h',
      description: 'Equipe especializada monitorando seu veículo todos os dias, sem interrupção, para sua total segurança.'
    },
    {
      icon: 'ri-gas-station-fill',
      title: 'Bloqueio de Combustível',
      description: 'Corte remoto de combustível para imobilizar o veículo em caso de roubo ou furto, aumentando as chances de recuperação.'
    },
    {
      icon: 'ri-notification-3-line',
      title: 'Alertas Inteligentes',
      description: 'Receba notificações instantâneas sobre movimentações suspeitas, violação de cerca eletrônica e muito mais.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Aplicativo Completo',
      description: 'Controle total pelo celular: visualize rotas, histórico de viagens, velocidade e gerencie todas as funções.'
    },
    {
      icon: 'ri-history-line',
      title: 'Histórico de Trajetos',
      description: 'Acesse relatórios detalhados de todos os percursos realizados, com data, hora e quilometragem.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Controle de Velocidade',
      description: 'Monitore a velocidade do veículo e receba alertas quando ultrapassar limites pré-estabelecidos.'
    },
    {
      icon: 'ri-map-2-line',
      title: 'Cerca Eletrônica',
      description: 'Defina áreas permitidas e seja notificado imediatamente quando o veículo sair da zona autorizada.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Suporte Especializado',
      description: 'Atendimento rápido e eficiente para tirar dúvidas e auxiliar em qualquer situação de emergência.'
    }
  ];

  return (
    <section id="beneficios" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Por Que Escolher a Rastrek?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tecnologia de ponta e recursos exclusivos para garantir a máxima proteção do seu veículo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-yellow-500 group cursor-pointer"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${benefit.icon} text-3xl text-black`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-yellow-500 to-yellow-400 rounded-2xl p-10 text-center">
          <h3 className="text-3xl font-bold text-black mb-4">
            Pronto para Proteger Seu Veículo?
          </h3>
          <p className="text-black/80 text-lg mb-6">
            Fale conosco agora e garanta a segurança que você merece
          </p>
          <a
            href="https://wa.me/5511954662476"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-black text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-900 transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
